import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/common/icon-note.svg'
import _imports_1 from '@/assets/img/common/icon-search-white.svg'
import _imports_2 from '@/assets/img/common/img-pagetop.svg'


const _hoisted_1 = { class: "l-wrapper" }
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-top" }
const _hoisted_4 = { class: "p-top-container" }
const _hoisted_5 = { class: "p-top-head" }
const _hoisted_6 = { class: "p-top-headingLv1" }
const _hoisted_7 = {
  key: 0,
  class: "p-top-container"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "p-top-headingBlock" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "p-top-headingLv2 -regular" }, "お知らせ")
], -1)
const _hoisted_9 = { class: "p-top-notice" }
const _hoisted_10 = { class: "p-top-container -fill -rd -blue" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "p-top-headingLv2 -blue" }, "応募管理", -1)
const _hoisted_12 = {
  key: 0,
  class: "p-top-container"
}
const _hoisted_13 = { class: "p-top-questionnaire" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<p class=\"p-top-questionnaire_label\">未入力あり</p><div class=\"p-top-questionnaire_box\"><div class=\"p-top-questionnaire_img\"><img src=\"" + _imports_0 + "\" alt=\"\" width=\"48\" height=\"48\"></div><p class=\"p-top-questionnaire_text\">転職希望アンケートをご入力いただくことで、<br>より有意義な求人紹介に繋がります。</p></div>", 2)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  class: "p-top-container splide",
  id: "splide02",
  "aria-labelledby": "job-carousel-02-heading"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", {
  class: "p-top-headingLv2",
  id: "job-carousel-02-heading"
}, "紹介求人", -1)
const _hoisted_19 = { class: "p-top-job splide__track" }
const _hoisted_20 = { class: "splide__list" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "p-top-splide-controls" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("ul", { class: "splide__pagination" }),
    /*#__PURE__*/_createElementVNode("div", { class: "splide__arrows" })
  ])
], -1)
const _hoisted_22 = { class: "p-top-container" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h2", { class: "p-top-headingLv2" }, "求人検索", -1)
const _hoisted_24 = ["onSubmit"]
const _hoisted_25 = { class: "p-jobsearch-search_section __clm" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "p-jobsearch-search_hl" }, "勤務地")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "p-jobsearch-search_btn js-modal-open-button",
    type: "button",
    "data-modal-target": "modalSearch2"
  }, "指定する")
], -1)
const _hoisted_28 = {
  key: 0,
  class: "p-jobsearch-search_data"
}
const _hoisted_29 = ["checked", "onChange"]
const _hoisted_30 = { class: "p-jobsearch-search_section __clm" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "p-jobsearch-search_hl" }, "職種")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "p-jobsearch-search_btn js-modal-open-button",
    type: "button",
    "data-modal-target": "modalSearch3"
  }, "指定する")
], -1)
const _hoisted_33 = {
  key: 0,
  class: "p-jobsearch-search_data"
}
const _hoisted_34 = ["checked", "onChange"]
const _hoisted_35 = {
  class: "p-top-search_button",
  type: "submit"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "職種マーク",
  width: "16",
  height: "16"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "検索する", -1)
const _hoisted_38 = {
  class: "p-jobsearch-search_second js-modal-container",
  id: "modalSearch2"
}
const _hoisted_39 = {
  class: "p-jobsearch-search_second js-modal-container",
  id: "modalSearch3"
}
const _hoisted_40 = { class: "l-wrapper_nav" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_43 = [
  _hoisted_42
]

import Loading from '@/components/Loading.vue';
import { onBeforeMount, watch } from 'vue';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import Splide from '@splidejs/splide';
import RecommendedJobCard from '@/components/RecommendedJobCard.vue';
import Keyword from '@/components/Keyword.vue';
import AnnualIncome from '@/components/AnnualIncome.vue';
import Location from '@/components/Location.vue';
import Occupation from '@/components/Occupation.vue';
import ApplyWidget from '@/components/ApplyWidget.vue';
import { RouterLink, useRouter } from 'vue-router';
import JobSearchSearchSaved from '@/components/JobSearchSearchSaved.vue';
import { DialogSearchSelectedData, TrnSerchMyPageInfo } from '@/api/services/trnSerchMyPageService';
import { formatNumber, jobSearchUtils } from '@/utils/jobSearch';
import { Job } from '@/types';
import { getRecommendedListService, setFavoriteService } from '@/api/services/shintyokuService';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { domHelperUtils } from '@/utils/domHelper';
import { getCareerInfoRecommendService } from '@/api/services/trnCareerService';
import MailSecurityExpiredPopupView from '../mailSecurity/MailSecurityExpiredPopupView.vue';
import MailSecurityWaitAuthenPopupView from '../mailSecurity/MailSecurityWaitAuthenPopupView.vue';
import MailSecuritySettingPopupView from '../mailSecurity/MailSecuritySettingPopupView.vue';

import { MypageNews } from '@/types';
import { TrnOrderJobSearchPublicRequest } from '@/types/request';
import { getJobSearchPublicService } from '@/api/services/trnOrderService';
import { cookieHelperUtils } from '@/utils/cookieHelper';
import AdvertisementView from './AdvertisementView.vue';
import { AdvertisementInfo } from '../../types/advertisement';
import { getAdvertisementService } from '../../api/services/advertisementService';
import { isShowWarningRecommendService } from '../../api/services/trnCareerService';
import _ from 'lodash';
import { MailSecurityInfoDetail } from '@/types/emailSerurity';

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const RECOMMENDED_LIMIT = 7;

const store = useStore();
const router = useRouter();
const isShowAdvertisement = ref<boolean>(false);
const displogLoginCount = ref<number>(0);
const isShowWarningRecommend = ref<boolean>(false);
const isShowMailSecurityExpiredPopup = ref(false);
const isShowMailSecurityWaitAuthenPopup = ref(false);
const isShowMailSecuritySettingPopup = ref(false);
const isMailSecuritySettingCloseable = ref(true);
const isShowMailSecurityPopupByDefault = ref(true);
const mailSecurityInfoRef = ref<MailSecurityInfoDetail|undefined>(undefined);

const isAction = ref(true);

const searchSectionSelectedData = ref<DialogSearchSelectedData>(_.cloneDeep(jobSearchUtils.defaultSearch));

// 求人カードのダミーデータ
const recommendedJobList = ref<Array<Job>>();

async function submitJobSearchPublic() {
  // チェックされた勤務地、職種、業種のみを保持する。
  const checkedLoc = searchSectionSelectedData.value.location
                      .displayLocationList
                      .filter(loc => loc.isChecked);
  const checkedOccup = searchSectionSelectedData.value.occupation
                      .displayOccupList
                      .filter(occup => occup.isChecked);

  searchSectionSelectedData.value.location.displayLocationList = checkedLoc;
  searchSectionSelectedData.value.occupation.displayOccupList = checkedOccup;

  jobSearchUtils.saveSearchConditionToSessionStorage(searchSectionSelectedData.value);
  jobSearchUtils.saveSearchCardToSessionStorage();
  router.push({name: 'h01'});
}

const jobSearchPublicParams = ref<TrnOrderJobSearchPublicRequest>({});
const zeroToNull = (val: number | null | undefined) => val ? val : undefined;
const countByCondition = ref('0');
const isActiveChangeConditionCount = ref(false);

async function changeCountByCondition(){
  countByCondition.value = '...';

  jobSearchPublicParams.value = {
    jobsearchOcupctg1id: searchSectionSelectedData.value.occupation.jobsearchOcupctg1id,
    jobsearchOcupctg2id: searchSectionSelectedData.value.occupation.jobsearchOcupctg2id,
    jobsearchOcupctg3id: searchSectionSelectedData.value.occupation.jobsearchOcupctg3id,
    jobsearchIndsctgGroupId: searchSectionSelectedData.value.industry.jobsearchIndsctgGroupId,
    jobsearchIndsctgId: searchSectionSelectedData.value.industry.jobsearchIndsctgId,
    jobsearchAnualslryValue: zeroToNull(searchSectionSelectedData.value.jobsearchAnualslry?.id),
    jobsearchFeaturesOrder: searchSectionSelectedData.value.jobsearchFeaturesOrder,
    jobsearchKeyword: searchSectionSelectedData.value.keyword,
    jobsearchFeatures: searchSectionSelectedData.value.jobsearchFeatures,
    jobsearchAreaid: searchSectionSelectedData.value.location.jobsearchAreaid,
    jobsearchPrefid: searchSectionSelectedData.value.location.jobsearchPrefid,
    jobsearchCityid: searchSectionSelectedData.value.location.jobsearchCityid,
    jobsearchPossibleOvertime: zeroToNull(searchSectionSelectedData.value.jobsearchPossibleOvertime?.id),
    jobsearchRemotework: zeroToNull(searchSectionSelectedData.value.jobsearchRemotework?.id),
    jobsearchSideBusiness: zeroToNull(searchSectionSelectedData.value.jobsearchSideBusiness),
  };

  await submitCountByCondition({ isCount: true });
}

async function submitCountByCondition(params?: TrnOrderJobSearchPublicRequest){
  const requestParams: TrnOrderJobSearchPublicRequest = {
    ...jobSearchPublicParams.value,
    ...(params || {}),
  };

  const orderPublicState = await getJobSearchPublicService(requestParams);

  countByCondition.value = formatNumber(orderPublicState.totalCount);
}

watch(() => searchSectionSelectedData.value, async () => {
  if(isActiveChangeConditionCount.value){
    jobSearchUtils.toggleDialogSearch('homeViewSearch', true);
    await changeCountByCondition();
    jobSearchUtils.toggleDialogSearch('homeViewSearch', false);
  }
}, { deep: true });

async function updateRecommendedJobFavorite(orderId: number, favorite: boolean) {
  if(!isAction.value)
  {
    return;
  }
  isAction.value = false;
  const idx = recommendedJobList.value!.findIndex((j) => Number(j.orderId) === orderId);
  if (idx >= 0) {
    const job = recommendedJobList.value![idx];
    job.isFavorite = favorite;
    const orderIds: number[] = [];
    orderIds.push(Number(job.orderId));
    const detailResp = await setFavoriteService({
      orderIds: orderIds,
      isFavorite: favorite
    });
    if(detailResp)
    {
      if (detailResp.orderId.length){
        const label = favorite ? MYPAGE_CONSTANTS.STRING.FAVORITE_DONE : MYPAGE_CONSTANTS.STRING.UN_FAVORITE_DONE;
        store.dispatch('toasts/appendTimeToast', {label});
      } else {
        jobSearchUtils.showMessageForInvalidOrders(store, recommendedJobList.value!, detailResp);
        job.isFavorite = !favorite;
      }
    }
    else
    {
      job.isFavorite = !favorite;
      store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.ERROR_FAVORITE});
    }
  }
  isAction.value = true;
}

async function loadRecommendedJobList(){
  const fetchedJob = await getRecommendedListService({
    page: 1,
    isExcludeOrderClose : true,
    limit: RECOMMENDED_LIMIT,
  });
  recommendedJobList.value = fetchedJob.shintyokuList;
}

function applySavedSearch(searchData: TrnSerchMyPageInfo) {
  router.push({name: 'h01', query: {searchId: searchData.srchId}});
}

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

function toJobSearch(){
  sessionStorage.removeItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_SORT);
  router.push({name: 'h00'});
}

onMounted(async () => {
  const careerInfo = await getCareerInfoRecommendService();
  if(careerInfo)
  {
      isShowWarningRecommend.value = await isShowWarningRecommendService(careerInfo);
  }
  
  await changeCountByCondition();
  isActiveChangeConditionCount.value = true;

  await loadRecommendedJobList();
  if (recommendedJobList.value?.length) {
    domHelperUtils.tooltip.initializeTooltips();
    // 紹介求人
    if (document.getElementById('splide02')) {
      const splide02 = new Splide( '#splide02', {
        // スライドの幅をコンテンツに合わせて自動調整する
        autoWidth: true,
        rewind: true,
        focus: 0,
        omitEnd: true,
      } );
      splide02.on('overflow', (isOverFlow: boolean) => {
        splide02.options = {
          arrows: isOverFlow,
          pagination: isOverFlow
        };
      });
      splide02.mount();
    }
  }
  
  isLoading.value = false; // ローディング終了
});

onUnmounted(() => {
  domHelperUtils.tooltip.removeTooltipEvents();
});

const menu = computed(() => {
  return store.getters['userMenu/userMenu'];
});

const mypageNewsList = ref<MypageNews[]>([]);

const isLoading = ref(false);
const adsDatas = ref<AdvertisementInfo[]>([]);

const locationRefreshKey = ref(0);
const occupationRefreshKey = ref(0);

function getMailSecurityHomePopupDismissKey(mailSecurityInfo: MailSecurityInfoDetail): string {
  return JSON.stringify({
    careerId: mailSecurityInfo.careerId ?? null,
    loginId: mailSecurityInfo.loginId ?? '',
    email1: mailSecurityInfo.email1 ?? '',
    email1AuthFlg: mailSecurityInfo.email1AuthFlg ?? 0,
    email2: mailSecurityInfo.email2 || mailSecurityInfo.pendingEmail2 || '',
    email2AuthFlg: mailSecurityInfo.email2AuthFlg ?? 0,
    hasEmail2AuthKey: !!mailSecurityInfo.hasEmail2AuthKey,
    isEmail2AuthExpired: !!mailSecurityInfo.isEmail2AuthExpired,
  });
}

function isMailSecurityHomePopupDismissed(mailSecurityInfo: MailSecurityInfoDetail): boolean {
  return sessionStorage.getItem(MYPAGE_CONSTANTS.SESSION_KEY.MAIL_SECURITY_HOME_POPUP_DISMISSED)
    === getMailSecurityHomePopupDismissKey(mailSecurityInfo);
}

function dismissMailSecurityHomePopup(): void {
  if (mailSecurityInfoRef.value?.email1AuthFlg !== 1) {
    return;
  }

  sessionStorage.setItem(
    MYPAGE_CONSTANTS.SESSION_KEY.MAIL_SECURITY_HOME_POPUP_DISMISSED,
    getMailSecurityHomePopupDismissKey(mailSecurityInfoRef.value)
  );
}

onBeforeMount(async () => {
  isLoading.value = true; // ローディング開始

  // Handle show Mail Security Setting Modal for first login
  await store.dispatch('mailSecurity/receive', true);
  const mailSecurityInfo = store.getters['mailSecurity/mailSecurity'] as MailSecurityInfoDetail;
  mailSecurityInfoRef.value = mailSecurityInfo;

  const isFirstLoginFlag = sessionStorage.getItem(MYPAGE_CONSTANTS.SESSION_KEY.IS_FIRST_LOGIN) === 'true';
  const email1Unverified = mailSecurityInfo?.email1AuthFlg !== 1;
  const email1PendingAuth = email1Unverified && !mailSecurityInfo?.isEmail1AuthExpired;
  const email1ExpiredAuth = email1Unverified && !!mailSecurityInfo?.isEmail1AuthExpired;
  const email2ForAuth = mailSecurityInfo?.email2 || mailSecurityInfo?.pendingEmail2;
  const email2Unverified = !!email2ForAuth && mailSecurityInfo?.email2AuthFlg !== 1;
  const email2PendingAuth = email2Unverified && !!mailSecurityInfo?.hasEmail2AuthKey;
  const showCloseableMailSecurityPopupByDefault = mailSecurityInfo?.email1AuthFlg === 1
    ? !isMailSecurityHomePopupDismissed(mailSecurityInfo)
    : true;
  if (isFirstLoginFlag || mailSecurityInfo?.isFirstLogin) {
    if (email1PendingAuth) {
      isMailSecuritySettingCloseable.value = false;
      isShowMailSecuritySettingPopup.value = true;
    } else if (email1ExpiredAuth) {
      isShowMailSecurityExpiredPopup.value = true;
    } else if (mailSecurityInfo?.email1AuthFlg === 1 && email2Unverified) {
      isShowMailSecurityPopupByDefault.value = showCloseableMailSecurityPopupByDefault;
      isShowMailSecurityWaitAuthenPopup.value = true;
    }
  } else if (email1ExpiredAuth) {
    // email1 auth key expired → show expired popup on Home
    isShowMailSecurityExpiredPopup.value = true;
  } else if (email1PendingAuth) {
    // email1 changed and pending verification → show non-dismissable verify popup
    isShowMailSecurityWaitAuthenPopup.value = true;
  } else if (email1Unverified) {
    // email1 unverified and no auth mail sent → show setting modal
    isMailSecuritySettingCloseable.value = false;
    isShowMailSecuritySettingPopup.value = true;
  } else if (email2PendingAuth) {
    // Handle show Mail Security Popup to verify Email2
    isShowMailSecurityPopupByDefault.value = showCloseableMailSecurityPopupByDefault;
    if(mailSecurityInfo.isEmail2AuthExpired) {
      isShowMailSecurityExpiredPopup.value = true;
    } else {
      isShowMailSecurityWaitAuthenPopup.value = true;
    }
  }

  // If the user has unverified email (email1 or email2), do not show advertisement
  const shouldSuppressAdvertisement =
    (isShowMailSecuritySettingPopup.value && !isMailSecuritySettingCloseable.value)
    || (isShowMailSecurityWaitAuthenPopup.value && email1Unverified)
    || (isShowMailSecurityExpiredPopup.value && email1Unverified);

  await store.dispatch('news/getList');
  const fetchedNewsList = store.getters['news/mypageNewsInfoList'];
  mypageNewsList.value = fetchedNewsList as MypageNews[];
  if (!shouldSuppressAdvertisement) {
    displogLoginCount.value = cookieHelperUtils.getCookie<number>(MYPAGE_CONSTANTS.COOKIE_TIMEOUT.ADVERTISEMENT_LOGIN_COUNT.NAME, 0)!;
    isShowAdvertisement.value = cookieHelperUtils.getCookie<boolean>(MYPAGE_CONSTANTS.COOKIE_TIMEOUT.ADVERTISEMENT_DIALOG.NAME, false)!;
    if(isShowAdvertisement.value)
    {
      adsDatas.value = await getAdvertisementService();
    }
  }
  cookieHelperUtils.removeCookie(MYPAGE_CONSTANTS.COOKIE_TIMEOUT.ADVERTISEMENT_DIALOG.NAME);
  cookieHelperUtils.removeCookie(MYPAGE_CONSTANTS.COOKIE_TIMEOUT.ADVERTISEMENT_LOGIN_COUNT.NAME);
});

// お知らせリストの件数をチェックするcomputedプロパティ
const hasNews = computed(() => mypageNewsList.value && mypageNewsList.value.length > 0);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(menu).lastname) + " " + _toDisplayString(_unref(menu).firstname) + "さま", 1)
            ])
          ]),
          _createElementVNode("section", null, [
            (_unref(hasNews))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("ul", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mypageNewsList.value, (news) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: news.newsId
                      }, [
                        _createVNode(_unref(RouterLink), {
                          class: "p-top-card-notice",
                          to: `/news/${news.newsId}`
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, _toDisplayString(news.newsTitle), 1),
                            _createElementVNode("span", null, _toDisplayString(news.dispdateFrom), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(ApplyWidget, { "class-prefix": "p-top" }, {
                header: _withCtx(() => [
                  _hoisted_11,
                  _createVNode(_unref(RouterLink), {
                    class: "p-top-pageLink -blue",
                    to: {name: 'n00'}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("すべて見る")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            (isShowWarningRecommend.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_unref(RouterLink), {
                      class: "p-top-questionnaire_link",
                      to: {name: 'q00'}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("転職希望アンケートを入力する")
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (recommendedJobList.value && recommendedJobList.value.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", { class: "p-top-headingBlock" }, [
                    _hoisted_18,
                    _createElementVNode("span", {
                      class: "p-top-pageLink -blue",
                      onClick: toJobSearch
                    }, "すべて見る")
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendedJobList.value, (job) => {
                        return (_openBlock(), _createBlock(RecommendedJobCard, {
                          key: job.orderId,
                          job: job,
                          "onUpdate:favorite": favorite => updateRecommendedJobFavorite(Number(job.orderId), favorite)
                        }, null, 8, ["job", "onUpdate:favorite"]))
                      }), 128))
                    ])
                  ]),
                  _hoisted_21
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(JobSearchSearchSaved, {
            "is-from-home": true,
            onApplySavedSearch: applySavedSearch
          }),
          _createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("form", {
                class: "p-top-search",
                id: "homeViewSearch",
                onSubmit: _withModifiers(submitJobSearchPublic, ["prevent"])
              }, [
                _createVNode(Keyword, {
                  "model-value": searchSectionSelectedData.value.keyword,
                  "onUpdate:model-value": _cache[0] || (_cache[0] = ($event: any) => ((searchSectionSelectedData.value.keyword) = $event))
                }, null, 8, ["model-value"]),
                _createVNode(AnnualIncome, {
                  "model-value": searchSectionSelectedData.value.jobsearchAnualslry,
                  "onUpdate:model-value": _cache[1] || (_cache[1] = ($event: any) => ((searchSectionSelectedData.value.jobsearchAnualslry) = $event))
                }, null, 8, ["model-value"]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _hoisted_27,
                  (searchSectionSelectedData.value.location.displayLocationList.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchSectionSelectedData.value.location.displayLocationList, (loc) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: loc.id,
                            class: "p-jobsearch-search_data_item"
                          }, [
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: loc.isChecked,
                                onChange: ($event: any) => (_unref(jobSearchUtils).updateLocationSearchData(searchSectionSelectedData.value, loc, ($event.target as HTMLInputElement).checked))
                              }, null, 40, _hoisted_29),
                              _createElementVNode("span", null, _toDisplayString(loc.text), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _hoisted_32,
                  (searchSectionSelectedData.value.occupation.displayOccupList.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchSectionSelectedData.value.occupation.displayOccupList, (occup) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: occup.id,
                            class: "p-jobsearch-search_data_item"
                          }, [
                            _createElementVNode("label", null, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: occup.isChecked,
                                onChange: ($event: any) => (_unref(jobSearchUtils).updateOccupationSearchData(searchSectionSelectedData.value, occup, ($event.target as HTMLInputElement).checked))
                              }, null, 40, _hoisted_34),
                              _createElementVNode("span", null, _toDisplayString(occup.text), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", _hoisted_35, [
                  _hoisted_36,
                  _hoisted_37,
                  _createTextVNode("（" + _toDisplayString(countByCondition.value) + "件） ", 1)
                ])
              ], 40, _hoisted_24),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(Location, {
                  "selected-locations": searchSectionSelectedData.value.location,
                  "onUpdate:selected-locations": _cache[2] || (_cache[2] = ($event: any) => ((searchSectionSelectedData.value.location) = $event)),
                  "refresh-key": locationRefreshKey.value
                }, null, 8, ["selected-locations", "refresh-key"])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(Occupation, {
                  "selected-occupations": searchSectionSelectedData.value.occupation,
                  "onUpdate:selected-occupations": _cache[3] || (_cache[3] = ($event: any) => ((searchSectionSelectedData.value.occupation) = $event)),
                  "refresh-key": occupationRefreshKey.value
                }, null, 8, ["selected-occupations", "refresh-key"])
              ])
            ])
          ])
        ]),
        (isShowAdvertisement.value)
          ? (_openBlock(), _createBlock(AdvertisementView, {
              key: 0,
              "displog-login-count": displogLoginCount.value,
              "ads-datas": adsDatas.value
            }, null, 8, ["displog-login-count", "ads-datas"]))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_40, [
        _createElementVNode("a", {
          class: "g-pagetop",
          href: "#",
          onClick: _withModifiers(scrollToTop, ["prevent"]),
          "aria-label": "ページトップへ戻る"
        }, _hoisted_43, 8, _hoisted_41)
      ], 512), [
        [_vShow, !isLoading.value]
      ])
    ]),
    (isShowMailSecuritySettingPopup.value)
      ? (_openBlock(), _createBlock(MailSecuritySettingPopupView, {
          key: 0,
          isCloseable: isMailSecuritySettingCloseable.value,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (isShowMailSecuritySettingPopup.value = false))
        }, null, 8, ["isCloseable"]))
      : _createCommentVNode("", true),
    (isShowMailSecurityExpiredPopup.value)
      ? (_openBlock(), _createBlock(MailSecurityExpiredPopupView, {
          key: 1,
          showPopupByDefault: isShowMailSecurityPopupByDefault.value,
          isCloseable: mailSecurityInfoRef.value?.email1AuthFlg === 1,
          onClose: dismissMailSecurityHomePopup
        }, null, 8, ["showPopupByDefault", "isCloseable"]))
      : _createCommentVNode("", true),
    (isShowMailSecurityWaitAuthenPopup.value)
      ? (_openBlock(), _createBlock(MailSecurityWaitAuthenPopupView, {
          key: 2,
          isShowVerifyButton: true,
          showPopupByDefault: isShowMailSecurityPopupByDefault.value,
          isCloseable: mailSecurityInfoRef.value?.email1AuthFlg === 1,
          hasEmail1AuthKey: !!mailSecurityInfoRef.value?.hasEmail1AuthKey,
          email1AuthFlg: mailSecurityInfoRef.value?.email1AuthFlg === 1,
          hasEmail2AuthKey: !!mailSecurityInfoRef.value?.hasEmail2AuthKey,
          email2AuthFlg: mailSecurityInfoRef.value?.email2AuthFlg === 1,
          email2: mailSecurityInfoRef.value?.email2 || mailSecurityInfoRef.value?.pendingEmail2 || '',
          onClose: dismissMailSecurityHomePopup,
          onAuthenticated: _cache[5] || (_cache[5] = ($event: any) => (isShowMailSecurityWaitAuthenPopup.value = false))
        }, null, 8, ["showPopupByDefault", "isCloseable", "hasEmail1AuthKey", "email1AuthFlg", "hasEmail2AuthKey", "email2AuthFlg", "email2"]))
      : _createCommentVNode("", true),
    _createVNode(Loading, {
      "is-loading": isLoading.value || !isAction.value
    }, null, 8, ["is-loading"])
  ], 64))
}
}

})